import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { addOfficeBMO } from "../../../../../actions/Utilities/OfficeBMO";
import { toast } from "../../../../../components/toastNotification";
import { OfficeBMOType } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { addStateOfficeBMO, officeBMOReFetching } from "../atoms/atoms";

export default function useAddOfficeBMO() {
  const setIsAddState = useSetRecoilState(addStateOfficeBMO);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeBMOReFetching
  );

  const { mutate } = useMutation(
    (NewData: OfficeBMOType) => addOfficeBMO(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Office BMO failed", res.Message, "error");
        } else {
          switch (true) {
            case res =="Success":
              toast.fire(
                "Success",
                "Office BMO Added Successfully",
                "success"
              );
              break;
              case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Office BMO Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res.includes("Operation Failed!"):
              toast.fire(
                "Adding Office BMO failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res.includes ("The data already exists!"):
              toast.fire(
                "Adding Office BMO failed",
                `Duplication Error: ${res}`,
                "error"
              );
                break;
            case res.includes("Action object is null!"):
                toast.fire(
                    "Adding Office BMO failed",
                    `Error: ${res}`,
                    "error"
                );
              break;
            default:
              toast.fire("Adding Office BMO failed", res.Message, "error");
          }
        }
          // Redirect to View
          setIsAddState(false);
          
          // ReFetch Data
          setIsReFetching(isReFetching ? false : true);
        },

        onError: (error: any) => {
          toast.fire("Add Office BMO failed", `Error: ${error}`, "error");
        },
      }
  );

  return mutate;
}
